import { Component, OnDestroy, OnInit } from '@angular/core';
import { expandEvent, ispe } from '@microsoft/sharepoint-recurring-events';
import * as _ from 'lodash';
import { Bounds } from '../../models/calendar/bounds.model';
import { CalendarEvent } from '../../models/calendar/calendar-event.model';
import { EventsService } from '../../services/events.service';
import { Base } from '../base/base';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';

@Component({
  selector: 'safetydirector-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css'],
  providers: [EventsService]
})
export class EventsComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private allEvents: CalendarEvent[];
  private allEventsArray: Array<CalendarEvent[]> = [];

  private size = 5;

  public tap = 0;
  public events: CalendarEvent[];
  public totalEventsBatch;

  constructor(private eventsService: EventsService, private eventTrackingService: EventTrackingService, ) {
    super();
  }

  ngOnInit(): void {
    const industry = this.getIndustry();

    this.BusyA = this
      .eventsService
      .getEvents(industry)
      .subscribe(result => {
        let allEvents: CalendarEvent[] = [];

        const bounds: Bounds = {
          start: new Date(),
          end: null
        }

        _.forEach(result, function (event: CalendarEvent) {
          if (event.title.indexOf("Deleted:") === -1) {
            let rawEvents: ispe = {
              Duration: event.fAllDayEvent ? 86400 : 3600,  // JDF Nishant Review Logic
              EndDate: event.endDate.toString(),
              EventDate: event.eventDate.toString(),
              fAllDayEvent: event.fAllDayEvent,
              fRecurrence: event.fRecurrence,
              RecurrenceData: event.recurrenceData
            };

            let expandedEvents = expandEvent(rawEvents, bounds);

            _.forEach(expandedEvents, function (expandedEvent: ispe) {
              allEvents.push({
                calendarDescription: event.calendarDescription,
                link: event.link,
                commonIndustry: event.commonIndustry,
                duration: expandedEvent.Duration,
                endDate: new Date(expandedEvent.EndDate),
                eventDate: new Date(expandedEvent.EventDate),
                fAllDayEvent: expandedEvent.fAllDayEvent,
                fRecurrence: expandedEvent.fRecurrence,
                recurrenceData: expandedEvent.RecurrenceData!,
                title: event.title
              })
            });
          }                  
        });

        this.allEvents = _.sortBy(allEvents, function (event) {
          return event.eventDate;
        });

        let totalEvents = this.allEvents.length;

        if (totalEvents > 0) {
          let start = 0;

          while (start < totalEvents) {
            let end = start + this.size;
            this.allEventsArray.push(this.allEvents.slice(start, end));
            start = end;
          }

          this.totalEventsBatch = this.allEventsArray.length;

          this.setPage();
        } else {
          this.events = [];
        }
      });
  }

  public trainingEventClick (link: string){
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event':  EventName.industryResourcesTrainingEvent,
      'TrainingEventUrl': link 
    });
  }
  private setPage() {
    this.events = this.allEventsArray[this.tap];
  }

  public prevPage() {
    if (this.tap > 0) {
      this.tap--;
      this.setPage();
    }
  }

  public nextPage() {
    if (this.tap < this.totalEventsBatch - 1) {
      this.tap++;
      this.setPage();
    }
  }

  public showEndDate(event: CalendarEvent) {
    const startTime = event.eventDate.getDay();
    const endTime = event.endDate.getDay()
    return startTime != endTime;
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }
  }
}
